/****************************************************
 * Module Name:  roughOriginMaster.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import { Box, Button, CircularProgress, TextField } from "@mui/material";
import React, { useState } from "react";
import logo from '../../images/pansuriya.jpg'
import { Modal, Form } from "react-bootstrap";
import { LoadingButton } from "@mui/lab";
import Constants from "../../utility/constants";
import SaveIcon from '@mui/icons-material/Save';
import Utility from "../../utility/utility";
import RoughOriginProxy from "../../utility/proxy/manager/roughOriginProxy";
// import CommonSnackbar from "../common/commonSnackBar";

const AddRoughOriginModal = ({
    handleSave,
    handleClose,
    editOperation,
    sourceData,
    loader
}) => {

    const [newRoughOrigin, setNewRoughOrigin] = useState(editOperation ? sourceData.roughorigin : "");
    const [newDescription, setNewDescription] = useState(editOperation ? sourceData.description : "");
    const [newCountryOfOrigin, setNewCountryOfOrigin] = useState(editOperation ? sourceData.countryoforigin : "");

    const [roughOriginLoader, setRoughOriginLoader] = useState(false);
    const [showValidationMessage, setShowValidationMessage] = useState(false);
    const [roughOriginAvailable, setRoughOriginAvailable] = useState(true);

    const [roughOriginValidationError, setRoughOriginValidationError] = useState("");
    const [countryOfOriginValidationError, setCountryOfOriginValidationError] = useState("");

    const addEditRoughOrigin = () => {
        let data = {
            id: editOperation ? sourceData.id : undefined,
            roughorigin: newRoughOrigin,
            description: newDescription,
            countryoforigin: newCountryOfOrigin
        };

        if (handleSave) {
            handleSave(data);
        }
    };

    const validateRoughOriginPresent = (roughOriginEntered) => {
        if (!roughOriginEntered || roughOriginEntered.trim() === "") return;

        setRoughOriginLoader(true);
        RoughOriginProxy.CheckRoughOriginAvailable(roughOriginEntered, (response) => {
            // If we got response that means rough origin is present at backend
            if (response.status === "Success") {
                // Rough Origin Name already present
                setRoughOriginLoader(false);
                setShowValidationMessage(true);
                setRoughOriginAvailable(false);
            } else {
                // Rough Origin Name not available, so can be used
                setRoughOriginLoader(false);
                setShowValidationMessage(true);
                setRoughOriginAvailable(true);
            }
        });
    };

    const buttonDisable = () => {
        if (editOperation && newCountryOfOrigin.length === 0)
            return true;

        if (!editOperation)
            return (
                !showValidationMessage ||
                !roughOriginAvailable ||
                newCountryOfOrigin.length === 0
            );

        return false;
    };

    return (
        <Box>
            <Modal
                backdrop="static"
                show={true}
                onHide={handleClose}
                enforceFocus={false}
            >

                <Modal.Header closeButton>
                    <Modal.Title>
                        <img
                            src={logo}
                            height="40pt"
                            width="40pt"
                            alt={Constants.COMPANY_SITE}
                        />
                        &nbsp;&nbsp;
                        {editOperation ? "Edit Rough Origin" : "Add New Rough Origin"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <center>
                        <table style={{ width: "100%" }}>
                            <tbody>
                                {editOperation && (
                                    <tr>
                                        <td><Form.Label>Rough Origin Id</Form.Label></td>
                                        <td><Form.Label>{sourceData.id}</Form.Label></td>
                                    </tr>
                                )}

                                <tr>
                                    <td><Form.Label>Rough Origin <sup style={{ color: "red" }}>*</sup></Form.Label></td>
                                    <td>
                                        <TextField
                                            margin="normal"
                                            fullWidth
                                            size="small"
                                            label="Rough Origin (required)"
                                            placeholder="Rough Origin"
                                            value={newRoughOrigin}
                                            autoFocus
                                            disabled={editOperation}
                                            onBlur={(e) => validateRoughOriginPresent(newRoughOrigin)}
                                            onChange={(e) => {
                                                setNewRoughOrigin(e.target.value);
                                                setShowValidationMessage(false);
                                                setRoughOriginValidationError(Utility.CheckIsPresent(e.target.value) ?
                                                    "" : "Rough Origin Cannot be Empty");
                                            }}
                                            helperText={roughOriginValidationError}
                                            error={roughOriginValidationError.length > 0}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        {roughOriginLoader ? (
                                            <CircularProgress size="1rem" />
                                        ) : !showValidationMessage ? (
                                            <Box>&nbsp;</Box>
                                        ) : roughOriginAvailable ? (
                                            <font color="green">Rough Origin available</font>
                                        ) : (
                                            <font color="red">Rough Origin not available</font>
                                        )}
                                    </td>
                                </tr>

                                <tr>
                                    <td><Form.Label>Country Of Origin<sup style={{ color: "red" }}>*</sup></Form.Label></td>
                                    <td>
                                        <TextField
                                            margin="normal"
                                            fullWidth
                                            size="small"
                                            label="Country Of Origin (required)"
                                            placeholder="Enter Country Of Origin"
                                            value={newCountryOfOrigin}
                                            onChange={(e) => {
                                                setNewCountryOfOrigin(e.target.value);
                                                setCountryOfOriginValidationError(Utility.CheckIsPresent(e.target.value) ?
                                                    "" : "Country Of Origin Cannot be Empty");
                                            }}
                                            helperText={countryOfOriginValidationError}
                                            error={countryOfOriginValidationError.length > 0}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td><Form.Label>Description</Form.Label></td>
                                    <td>
                                        <TextField
                                            margin="normal"
                                            fullWidth
                                            size="small"
                                            label="Description"
                                            placeholder="Enter Description"
                                            value={newDescription}
                                            onChange={(e) => setNewDescription(e.target.value)}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </center>
                </Modal.Body>
                <Modal.Footer>
                    <LoadingButton
                        loading={loader}
                        loadingPosition="start"
                        startIcon={<SaveIcon />}
                        variant="contained"
                        onClick={() => addEditRoughOrigin()}
                        disabled={buttonDisable()}
                        sx={{ mr: 1 }}
                    >
                        Save
                    </LoadingButton>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={handleClose}
                        disabled={loader}
                    >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </Box >
    )
}

export default AddRoughOriginModal;